import LoaderSuspense from './_loader-suspense.js'
import SportIcons from './_sport-icons.js'
import MenuRow from './_menu-row.js'
import Text from './_text.js'
import MenuRowSkeleton from './_menu-row-skeleton.js'

export default {
  name: 'MenuLinkPromotions',
  values: {
    locationId: undefined,
    extraLinksInFront: false,
    reportLoadingStatus: false,
    skeletonLoader: {
      configSet: LoaderSuspense,
      configValues: {},
    },
    sportIcons: {
      configSet: SportIcons,
      configValues: {},
    },
    menuRow: {
      configSet: MenuRow,
      configValues: {
        item: {
          unselected: {
            style: {
              base: {
                padding: '0px',
              },
            },
          },
          selected: {
            style: {
              base: {
                padding: '0px',
              },
            },
          },
        },
        itemInnerContainer: {
          style: {
            boxSizing: 'border-box',
            padding: '0 4px',
          },
        },
        itemLabel: {
          container: {
            width: '100%',
          },
          style: {
            textAlign: 'center',
          },
        },
        itemIcon: {
          style: {
            minHeight: '16px',
            maxHeight: '16px',
            minWidth: '16px',
            maxWidth: '16px',
          },
        },
      },
      itemLabel: {
        configSet: Text,
        configValues: {},
      },
    },
    menuRowSkeleton: {
      configSet: MenuRowSkeleton,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
